import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Landing from "../Containers/Landing";
import { APP_PAGES } from "../pages";
import Search from "../Containers/Search";
import { CustomerDetails } from "../Containers/CustomerDetails";
import Login from "../Containers/Auth";
import ProtectedRoute from "./ProtectedRoute";
import ResourceListing from "../Containers/Resource";
import Query from "../Containers/Docs/Query";
import Library from "../Containers/Docs/Library";
import Upload from "../Containers/Docs/Upload";
import Detail from "../Containers/Docs/Detail";

/** Preserve query string when redirecting legacy /search URLs to /. */
const RedirectSearchToHome = () => {
  const location = useLocation();
  return <Navigate to={`${APP_PAGES.SEARCH}${location.search}`} replace />;
};

const RouteConfig = () => {
  return (
    <Routes>
      <Route
        path={APP_PAGES.SEARCH}
        element={
          <ProtectedRoute>
            <Search />
          </ProtectedRoute>
        }
      />
      <Route
        path={APP_PAGES.DOCS}
        element={
          <ProtectedRoute>
            <Query />
          </ProtectedRoute>
        }
      />
      <Route
        path={APP_PAGES.DOCS_LIBRARY}
        element={
          <ProtectedRoute>
            <Library />
          </ProtectedRoute>
        }
      />
      <Route
        path={APP_PAGES.DOCS_UPLOAD}
        element={
          <ProtectedRoute>
            <Upload />
          </ProtectedRoute>
        }
      />
      <Route
        path={APP_PAGES.DOCS_DETAIL}
        element={
          <ProtectedRoute>
            <Detail />
          </ProtectedRoute>
        }
      />
      <Route
        path={APP_PAGES.CUSTOMERS_HOME}
        element={
          <ProtectedRoute>
            <Landing />
          </ProtectedRoute>
        }
      />
      <Route path="/login" element={<Login />} />
      <Route path="/search" element={<RedirectSearchToHome />} />
      <Route
        path={APP_PAGES.RESOURCES}
        element={
          <ProtectedRoute>
            <ResourceListing />
          </ProtectedRoute>
        }
      />
      <Route
        path={APP_PAGES.CUSTOMER_DETAILS}
        element={
          <ProtectedRoute>
            <CustomerDetails />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default RouteConfig;
